
import { ComponentInternalInstance, defineComponent, getCurrentInstance, toRefs, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import useDealerSelect from "@/composables/useDealerSelect";
import { useField } from "vee-validate";

export default defineComponent({
  props: {
    label: {
      type: String,
      default: 'formularios.concesionaria.label'
    },
    modelValue: {
      type: Number,
      requered: true
    },
    loacality: {
      type: Number,
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n()
    const { loacality } = toRefs(props)
    const { dealers, loading, getDealers } = useDealerSelect(loacality)
    const instance = getCurrentInstance() as ComponentInternalInstance;

    const {
      value: val,
      errorMessage,
      meta
    } = useField(
        'input-' + instance.uid.toString(),
        { required: props.required },
        {
          initialValue: props.modelValue,
          label: t(props.label).toString().toLowerCase()
        }
    )

    watch(loacality, async () => {
      await getDealers()
      emit('update:modelValue', null)
    })

    watch(val, val => {
          emit('update:modelValue', val)
        }
    )


    return {
      t,
      val,
      dealers,
      loading,
      errorMessage,
      meta
    }
  }
})
